import { observer } from 'mobx-react-lite'
import { OCRBulkProgressDialog } from '@/features/jobs/scoping/components/OCRBulkProgressDialog'
import { type OCRBulkProgressDialogViewModel } from './OCRBulkProgressDialogViewModel'

export interface OCRBulkProgressDialogContainerProps {
  vm: OCRBulkProgressDialogViewModel
}

export const OCRBulkProgressDialogContainer = observer(
  function OCRBulkProgressDialogContainer({
    vm,
  }: OCRBulkProgressDialogContainerProps) {
    return (
      <OCRBulkProgressDialog
        showing={vm.modal.showing}
        progress={vm.progress}
        completedCount={vm.completedCount}
        selectedCount={vm.selectedCount}
        isProcessing={vm.process.pending}
        hasErrors={vm.hasErrors}
        cancelled={vm.cancelled}
        completedSuccessfullyCount={vm.completedSuccessfullyCount}
        errorCount={vm.errorCount}
        onCancel={vm.cancel}
        onClose={vm.modal.close}
      />
    )
  },
)
